// Marca da plataforma: fixa no código (SaaS, sem customização por instalação).
export const BRAND_NAME = 'Ingrave Argentic';
export const BRAND_ICON = '/favicon.png';
export const BRAND_MARK = '/logo-thumbnail.svg';
export const BRAND_LOGO = '/ingrave-logo.svg';
